import Link from 'next/link'
import Image from 'next/image'

import Layout from 'components/layout'
import { ProductCardIndex } from 'components/shop/productCard'

export default function categoriePreview({ title, href, shouldHaveBg = false, products }) {
  return (
    <div className={`${shouldHaveBg ? 'bg-yellow-50' : ''} w-full py-12`}>
      <Layout>
        <h2 className="mb-8 font-serif text-4xl font-bold text-yellow xl:sr-only">{title}</h2>
        <div className="relative">
          <ul className="grid gap-12 md:grid-cols-3">
            {products.map(({ node: thisProduct }) => (
              <li key={thisProduct.id}>
                <ProductCardIndex
                  name={thisProduct.title}
                  imageData={thisProduct.featuredImage}
                  href={`/shop/product/${thisProduct.handle}`}
                />
              </li>
            ))}
          </ul>

          <div className="absolute top-[calc(50%-1.5rem)] -right-20 hidden xl:block" aria-hidden={true}>
            <Link href={href}>
              <a className="inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-yellow text-yellow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 34 34"
                  className="h-8 w-8"
                  stroke="currentColor">
                  <path strokeWidth={2} d="M32 17H17M17 17H2M17 17V2M17 17V32.5" />
                </svg>
              </a>
            </Link>
          </div>

          <div className="absolute -right-36 top-0 hidden h-full w-8 xl:inline-block" aria-hidden={true}>
            <Link href={href}>
              <a className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-90 transform whitespace-nowrap font-serif text-5xl font-bold text-yellow">
                {title.toLowerCase()}
              </a>
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center xl:sr-only">
          <Link href={href}>
            <a className="inline-block border-2 border-orange bg-orange px-4 py-2 font-medium uppercase text-white">
              Voir tous les produits
            </a>
          </Link>
        </div>
      </Layout>
    </div>
  )
}
